import { lazy } from "react";
import type { RouteObject } from "react-router";

const DashboardPage = lazy(() => import("./views/dashboard"));

const strategicProjects: RouteObject = {
  id: "strategic-projects",
  path: "/strategic-projects",
  element: <DashboardPage />,
};

export default strategicProjects;
